import React from "react";

const FormGrid = ({ cols = 2, children }) => (
  <div className={`form-grid cols-${cols}`}>{children}</div>
);

export default FormGrid;
